module.exports = __webpack_public_path__ + "img/festa4.44d9e690.png";